import styled from 'styled-components';

const Icon = styled.i`
  display: block;
  margin-right: 10px;
  font-size: 24px;
`;

export default Icon;
